"use strict";

require("console-polyfill");

function InitUtils() {
    var isFunction = function (object) {
        return !!(object && object.constructor && object.call && object.apply);
    };

    var isArray = function (object) {
        return object && object.constructor === Array;
    };

    var isBoolean = function (value) {
        return value === true || value === false;
    };

    /**
     * Accepts varargs expecting each argument to be an object, then
     * immutably merges the properties of each object and returns result.
     *
     * When multiple objects contain the same key the later object in
     * the arguments list will take precedence.
     *
     * Example:
     *
     * ```js
     * var result = merge({foo: 123}, {foo: 456});
     * console.log(result.foo); // outputs 456
     * ```
     *
     * @param {Object} obj1 Object to merge
     * @returns {Object} Result of all merge properties
     */
    function merge(/* obj1, obj2, obj3, ... */) {
        var result = {};
        function assignValue(val, key) {
            if (isPlainObject(result[key]) && isPlainObject(val)) {
                result[key] = merge(result[key], val);
            } else if (isPlainObject(val)) {
                result[key] = merge({}, val);
            } else if (isArray(val)) {
                result[key] = val.slice();
            } else {
                result[key] = val;
            }
        }

        for (var i = 0, l = arguments.length; i < l; i++) {
            forEach(arguments[i], assignValue);
        }
        return result;
    }

    /**
     * Iterate over an Array or an Object invoking a function for each item.
     *
     * If `obj` is an Array callback will be called passing
     * the value, index, and complete array for each item.
     *
     * If 'obj' is an Object callback will be called passing
     * the value, key, and complete object for each property.
     *
     * @param {Object|Array} obj The object to iterate
     * @param {Function} fn The callback to invoke for each item
     */
    function forEach(obj, fn) {
        // Don't bother if no value provided
        if (obj === null || typeof obj === "undefined") {
            return;
        }

        // Force an array if not already something iterable
        if (typeof obj !== "object") {
            /*eslint no-param-reassign:0*/
            obj = [obj];
        }

        if (isArray(obj)) {
            // Iterate over array values
            for (var i = 0, l = obj.length; i < l; i++) {
                fn.call(null, obj[i], i, obj);
            }
        } else {
            // Iterate over object keys
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    fn.call(null, obj[key], key, obj);
                }
            }
        }
    }

    /**
     * Determine if a value is a plain Object
     *
     * @param {Object} val The value to test
     * @return {boolean} True if value is a plain Object, otherwise false
     */
    function isPlainObject(val) {
        if (toString.call(val) !== "[object Object]") {
            return false;
        }

        var prototype = Object.getPrototypeOf(val);
        return prototype === null || prototype === Object.prototype;
    }

    var doCallback = function (hook, config, arg, deprecated) {
        if (config.callbacks && this.isFunction(config.callbacks[hook])) {
            if (deprecated) {
                this.logDeprecated(hook + " callback has been replaced, please see docs");
            }
            config.callbacks[hook](arg);
        }
        this.logDebug(['Trigger callback "' + hook + '" with arguments:', arg], config);
    };

    var logDebug = function (message, config) {
        if (config.debug) console.log("TimumBooking Debug: ", message);
    };

    var logError = function (message) {
        console.warn("TimumBooking Error: ", message);
    };

    var logDeprecated = function (message) {
        console.warn("TimumBooking Deprecated: ", message);
    };

    var doesConfigExist = function (suppliedConfig) {
        return suppliedConfig !== undefined && typeof suppliedConfig === "object" && !$.isEmptyObject(suppliedConfig);
    };

    var getPaddingHorizontal = function (element) {
        if(element){
            return element.innerWidth() - element.width();
        }
        return 0;
    }

    var getPaddingVertical = function (element) {
        if(element){
            return element.innerHeight() - element.height();
        }
        return 0;
    }

    return {
        isFunction: isFunction,
        isArray: isArray,
        isBoolean: isBoolean,
        isPlainObject: isPlainObject,
        merge: merge,
        forEach: forEach,
        doCallback: doCallback,
        logDebug: logDebug,
        logError: logError,
        logDeprecated: logDeprecated,
        doesConfigExist: doesConfigExist,
        getPaddingHorizontal: getPaddingHorizontal,
        getPaddingVertical: getPaddingVertical
    };
}

module.exports = InitUtils;
